<div class="container">
  <site-list-header></site-list-header>
  <site-list></site-list>

  <div class="actions">
    @if ((organizationCount$ | async); as count) {
      <div>
        <button [hidden]="count == 1"
          mat-icon-button
          matTooltip="{{'select_organization' | transloco}}" (click)="displayOrganizations()">
          <mat-icon>compare_arrows</mat-icon>
        </button>
      </div>
    }
    @if ((user$ | async); as user) {
      <button
        mat-icon-button
        matTooltip="{{'logout' | transloco}}" (click)="logout()">
        <mat-icon>logout</mat-icon>
      </button>
    }
  </div>
</div>
